<template>
  <div class="flex w-full items-center justify-between gap-x-0.5 md:gap-x-1.5 lg:justify-center lg:gap-x-4">
    <UiButton
      v-if="!hideArrows"
      icon="mdi:arrow-left"
      class="h-12 w-12 !bg-black !text-white"
      :class="{'cursor-not-allowed opacity-50': !hasPrev}"
      @click="hasPrev && $emit('prev')"
    />

    <ol class="flex flex-row flex-nowrap items-center gap-x-0.5 md:gap-x-1.5">
      <template v-for="index in props.size">
        <li
          v-if="shouldShowDotsTail(index)"
          :key="index"
          class="mx-1 hidden sm:list-item"
        >
          ...
        </li>

        <li
          v-if="shouldShowIndex(index)"
          :key="index"
        >
          <UiButton
            :class="[index-1 === props.page ? 'cursor-auto !bg-primary text-white' : 'bg-transparent']"
            class="h-12 w-12 rounded-full !bg-black !text-white"
            :label="index"
            @click="$emit('page-change',index - 1)"
          />
        </li>

        <li
          v-if="shouldShowDotsHead(index)"
          :key="index"
          class="mx-1 hidden sm:list-item"
        >
          ...
        </li>
      </template>
    </ol>

    <UiButton
      v-if="!hideArrows"
      class="h-12 w-12 !bg-black !text-white"
      :class="{'cursor-not-allowed opacity-50': !hasNext}"
      icon="mdi:arrow-right"
      @click="hasNext && $emit('next')"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  size: number
  page: number
  sideDotSize?: number
  hideArrows?: boolean
  hasNext: boolean
  hasPrev: boolean
}>();

defineEmits<{
  (e: 'page-change', newIndex: number): void
  (e: 'next'): void,
  (e: 'prev'): void,
}>();

const shouldShowIndex = (index: number) => {
  if (!props.sideDotSize) { return true; }

  if (index === 1) { return true; }
  if (index === props.size) { return true; }
  if (props.page + 1 < index + props.sideDotSize && props.page + 1 > index - props.sideDotSize) { return true; }

  return false;
};

const shouldShowDotsHead = (index: number) => {
  if (!props.sideDotSize) { return false; }
  if (index === 1 && props.page - props.sideDotSize > 0) { return true; }

  return false;
};

const shouldShowDotsTail = (index: number) => {
  if (!props.sideDotSize) { return false; }
  if (index === props.size - 1 && props.page + props.sideDotSize < props.size - 1) { return true; }

  return false;
};

</script>
